<div class="dialogContainer">
  @if (person) {
    <div>
      <table>
        <tr>
          <td><label>E-Mail Address:</label></td>
          <td class="dataColumn"><label>{{ person.emailAddress.emailAddress }}</label></td>
        </tr>
        <tr>
          <td class="rightAligned"><label>Phone #:</label></td>
          <td class="dataColumn"><label>{{ person.defaultPhoneNumber }}</label></td>
        </tr>
      </table>
    </div>
  }
  <div mat-dialog-actions>
    <span class="spacer"></span>
    <span>
      <button class="primary-button" matButton="elevated" (click)="close()">close</button>
    </span>
  </div>
</div>
